export class TextStyle {
    constructor() {
        this.font = "";
        this.fontSize = 12;
        this.color = "#000000";
        this.bold = false;
        this.italic = false;
        this.underline = false;
        this.underlineColor = null;
        this.strikethrough = false;
        this.strikethroughColor = null;
        this.align = 'left';
        this.valign = 'top';
        this.leading = 2;
        this.stroke = 0;
        this.strokeColor = '#000000';
        this.font = "";
        this.fontSize = 12;
        this.color = "#000000";
        this.bold = false;
        this.italic = false;
        this.underline = false;
        this.underlineColor = null;
        this.align = "left";
        this.valign = "top";
        this.alignItems = "middle";
        this.leading = 2;
        this.stroke = 0;
        this.strokeColor = "#000000";
    }
}
